import React from "react";
import img from "../Assets/505.png";

const ErrorPage = () => {
    // To Navigate on any other page
    // const navigate = useNavigate();

    return (
        <div className="flex items-center justify-center min-h-screen dark:bg-black dark:text-white">
            <div className="text-center grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-1">
                    <img src={img} alt="Error" className="w-full h-auto max-w-md mx-auto" />
                </div>
                <div className="md:col-span-1 mt-5 md:mt-0">
                    <p className="text-2xl font-semibold">
                        <span className="text-red-500">Opps!</span> Something Went Wrong.
                    </p>
                    <p className="text-lg text-gray-600 mt-2">
                        The page you’re looking for doesn’t exist.
                    </p>
                    {/* <button onClick={() => navigate("/")} className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                        Go Home
                    </button> */}
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;